export function sortBy<T>(items: T[], selector: (item: T) => string | number): T[] {
  const sorted = [...items];
  return sorted.sort((a, b) => {
    const left = selector(a) as any;
    const right = selector(b) as any;
    return left > right ? 1 : -1;
  });
}